import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipeAds'
})
export class FilterPipeAds implements PipeTransform {
    transform(elements: any, term?: any): any {
        if (term === undefined) return elements;
        if (term === null) return elements;

        if (elements != null) {
            return elements.filter(function (element) {
                if (element.name != undefined)
                    if (element.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return element;
                if (element.tags != undefined)
                    if (element.tags.toString().toLowerCase().includes(term.toLowerCase()))
                        return element;

            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/ads/filter.pipe.ts